<template>
  <div>
    <v-container fill-height fluid>
      <v-row>
        <v-col class="pa-0" xs="12" md="12">
          <v-card class="mx-auto px-2" outlined>
            <v-row>
              <v-col md="6">
                <div class="px-2 primary--text font-weight-bold">
                  {{ $vuetify.lang.t("$vuetify.gpt_dataset.dataset_document_header_txt") }}
                </div>
              </v-col>
              <!-- Action Buttons -->
              <v-col md="6">
                <div class="d-flex float-right">
                  <v-btn
                    v-if="selectedDocuments.length > 0"
                    class="text-capitalize ml-2"
                    color="primary"
                    @click="
                      download_alert_message = $vuetify.lang.t(
                        '$vuetify.gpt_dataset.confirm_alert_msg_selected_download'
                      );
                      downloadDialog = true;
                    "
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  >
                    <v-icon left>mdi-download</v-icon>
                    <span class="hidden-sm-and-down">
                      {{ $vuetify.lang.t("$vuetify.common.download_btn") }} ({{ selectedDocuments.length }})
                    </span>
                  </v-btn>
                  <v-btn
                    class="text-capitalize ml-2"
                    @click="handleCSVUpload()"
                    color="primary"
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  >
                    <v-icon left>mdi-upload</v-icon>
                    <span class="hidden-sm-and-down">
                      {{ $vuetify.lang.t("$vuetify.common.upload_btn") }}
                    </span>
                  </v-btn>
                  <v-btn
                    class="text-capitalize ml-2"
                    color="primary"
                    @click="
                      download_alert_message = $vuetify.lang.t('$vuetify.gpt_dataset.confirm_alert_msg_all_download');
                      downloadAllDocumentsDialog = true;
                    "
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  >
                    <v-icon left>mdi-folder-download</v-icon>
                    <span class="hidden-sm-and-down">
                      {{ $vuetify.lang.t("$vuetify.project.dataset") }}
                    </span>
                  </v-btn>
                  <v-btn
                    class="text-capitalize ml-2"
                    color="primary"
                    @click="historyDialog = true"
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  >
                    <v-icon left>mdi-history</v-icon>
                    <span class="hidden-sm-and-down">
                      {{ $vuetify.lang.t("$vuetify.common.history") }}
                    </span>
                  </v-btn>
                  <v-btn
                    class="text-capitalize ml-2"
                    @click="createNewDocumentClick()"
                    color="primary"
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                  >
                    <v-icon left>mdi-plus-circle-outline</v-icon>
                    <span class="hidden-sm-and-down">
                      {{ $vuetify.lang.t("$vuetify.gpt_document.create_document") }}
                    </span>
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-row>
              <v-col cols="12" xs="12" md="3">
                <v-text-field
                  v-model="search_text"
                  append-icon="mdi-magnify"
                  :label="$vuetify.lang.t('$vuetify.gpt_document.search_btn_text')"
                  outlined
                  dense
                  single-line
                  hide-details
                  @change="handleQueryOnDocuments"
                ></v-text-field>
              </v-col>
              <v-col v-if="!isTimeSeries" cols="12" xs="12" md="3">
                <v-select
                  :items="document_status_states"
                  item-text="state"
                  item-value="value"
                  v-model="selected_document_state"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  dense
                  @change="handleQueryOnDocuments"
                  :label="$vuetify.lang.t('$vuetify.gpt_dataset.active_status')"
                ></v-select>
              </v-col>
              <v-col v-if="!isTimeSeries" cols="12" xs="12" md="3">
                <v-select
                  :items="training_status_states"
                  item-text="state"
                  item-value="value"
                  v-model="selected_training_state"
                  persistent-hint
                  hide-details="auto"
                  outlined
                  dense
                  @change="handleQueryOnDocuments"
                  :label="$vuetify.lang.t('$vuetify.gpt_dataset.train_status')"
                ></v-select>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" xs="12" md="3" class="d-flex justify-end">
                <v-btn
                  class="text-capitalize"
                  color="error"
                  @click="
                    delete_alert_message = selectedDocuments.length
                      ? $vuetify.lang.t('$vuetify.gpt_dataset.confirm_alert_msg_txt_3')
                      : $vuetify.lang.t('$vuetify.gpt_dataset.confirm_alert_msg_txt_2');
                    deleteDialog = true;
                  "
                  :disabled="isDeleteDisabled"
                >
                  <v-icon>mdi-delete</v-icon>
                  <span>
                    {{ $vuetify.lang.t("$vuetify.tooltip.delete") }} ({{ selectedDocuments.length || "ALL" }})
                  </span>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-data-table
              :headers="dynamicTableHeaders"
              :items="gptDocuments"
              :search="search"
              hide-default-footer
              show-select
              v-model="selectedDocuments"
              :options.sync="options"
              :server-items-length="pageCount"
              :loading="isLoading"
              loading-text=""
            >
              <template #progress>
                <Loader class="mr-2 mt-6" />
              </template>
              <template #[`item.id`]="{ item }">
                <v-tooltip bottom>
                  <template #activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ item && item.id ? item.id.slice(0, 8) : "N/A" }}
                    </span>
                  </template>
                  <span>{{ item.id }}</span>
                </v-tooltip>
              </template>
              <template #[`item.data.name`]="{ item }">
                <div>
                  <v-btn text class="primary--text text--darken-3" @click="detailsModal(item)">{{
                    item.data.name
                  }}</v-btn>
                </div>
              </template>
              <template v-if="isTimeSeries" #[`item.primary_datetime_field`]="{ item }">
                {{ item.data[selectedDataset?.primary_datetime_field] }}
              </template>
              <template #[`item.created_at`]="{ item }">
                {{ formatDateTime(item.created_at) }}
              </template>
              <template #[`item.updated_at`]="{ item }">
                {{ formatDateTime(item.updated_at) }}
              </template>
              <template #[`item.status`]="{ item }">
                <v-chip color="primary" text-color="white" small class="text-capitalize">{{ item.status }}</v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <ButtonGroup
                  class="d-flex justify-center"
                  :groupType="ACTION_BUTTON_GROUP"
                  :addButton="false"
                  :startButton="false"
                  :stopButton="false"
                  :disabledDeleteButton="!$hasProjectAccessFor([$pRole.ADMIN])"
                  :disabledEditButton="!$hasProjectAccessFor([$pRole.ADMIN])"
                  @onDetailsClick="detailsModal(item)"
                  @onEditClick="updateItem(item)"
                  @onDeleteClick="deleteItem(item)"
                />
              </template>
            </v-data-table>
            <v-row>
              <v-col class="py-0" cols="12">
                <v-divider></v-divider>
              </v-col>
              <!-- Pagination limit notice -->
              <v-col cols="12" v-if="paginationLimitNotice" class="text-center py-1">
                <span class="caption">{{ paginationLimitNotice }}</span>
              </v-col>

              <!-- Total number of documents -->
              <v-col cols="12" sm="4" md="3" class="d-flex align-center justify-center justify-sm-start">
                <v-chip label class="ml-sm-4 ml-md-6">
                  <span>{{ $vuetify.lang.t("$vuetify.gpt_document.document_count") }}: {{ totalHits }}</span>
                </v-chip>
              </v-col>

              <!-- pagination -->
              <v-col cols="12" sm="5" md="6" class="d-flex align-center justify-center">
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
              </v-col>

              <!-- rows per page -->
              <v-col cols="12" sm="3" md="3" class="d-flex align-center justify-center justify-sm-end">
                <v-select
                  v-model="itemsPerPage"
                  :items="rows"
                  hide-details="auto"
                  outlined
                  dense
                  style="max-width: 140px"
                ></v-select>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <template v-if="detailsDialog">
      <v-dialog
        v-model="detailsDialog"
        max-width="800px"
        persistent
        scrollable
        hide-overlay
        transition="dialog-bottom-transition"
        content-class="rounded-lg"
        elevation="24"
        rounded
      >
        <v-card class="rounded-lg" elevation="24" rounded v-if="!detailsLoader">
          <v-card-title>
            {{ $vuetify.lang.t("$vuetify.tooltip.document") }}
            {{ $vuetify.lang.t("$vuetify.common.details_header_txt") }}
          </v-card-title>
          <v-card-text>
            <div>{{ $vuetify.lang.t("$vuetify.table_header.id_header_txt") }}: {{ document_details.id }}</div>
            <div v-if="document_details?.active_status">
              {{ $vuetify.lang.t("$vuetify.dashboard.active") }} {{ $vuetify.lang.t("$vuetify.table_header.status") }}:
              <span class="text-capitalize">{{ document_details.active_status }}</span>
            </div>
            <div>
              {{ $vuetify.lang.t("$vuetify.table_header.created_at") }}:
              {{ formatDateTime(document_details.created_at) }}
            </div>
            <div v-if="!isTimeSeries && !isDictionaryDataset">
              {{ $vuetify.lang.t("$vuetify.table_header.status") }}:
              <span class="text-capitalize">{{ document_details.status }}</span>
            </div>
            <v-container>
              <v-row class="pa-0 ma-0">
                <v-col class="py-1 my-0" cols="6"
                  ><strong>{{ $vuetify.lang.t("$vuetify.gpt_document.document_key") }}</strong></v-col
                >
                <v-col class="py-1 my-0" cols="6"
                  ><strong>{{ $vuetify.lang.t("$vuetify.gpt_document.document_value") }}</strong></v-col
                >
              </v-row>
              <v-row class="pa-0 ma-0" v-for="(value, key) in document_details.data" :key="key">
                <v-col class="py-1 my-0" cols="6">{{ key }}</v-col>
                <v-col class="py-1 my-0" cols="6">{{ value }}</v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn text color="error" @click="detailsDialog = false">
              {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <Loader v-else />
      </v-dialog>
    </template>

    <template v-if="createNewDocumentDialog">
      <v-dialog
        v-model="createNewDocumentDialog"
        max-width="800px"
        persistent
        scrollable
        hide-overlay
        transition="dialog-bottom-transition"
        content-class="rounded-lg"
        elevation="24"
        rounded
      >
        <v-card class="rounded-lg" elevation="24" rounded>
          <v-card-title>
            {{
              toBeUpdatedDocumentId !== ""
                ? $vuetify.lang.t("$vuetify.gpt_document.update_document")
                : $vuetify.lang.t("$vuetify.common.create") +
                  " " +
                  $vuetify.lang.t("$vuetify.gpt_document.create_document")
            }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="pa-0">
                <p class="text-center font-weight-bold pa-0 ma-0">
                  {{ $vuetify.lang.t("$vuetify.gpt_document.document_key") }}
                </p>
              </v-col>
              <v-col cols="12" md="8" class="pa-0">
                <p class="text-center font-weight-bold pa-0 ma-0">
                  {{ $vuetify.lang.t("$vuetify.gpt_document.document_value") }}
                </p>
              </v-col>
            </v-row>
            <hr class="my-2" />
            <v-form ref="document_form">
              <v-row class="pa-0 ma-0" v-for="(newDocument, index) in newDocuments" :key="index">
                <v-col class="py-0 my-0" cols="12" md="4">
                  <v-text-field
                    v-model="newDocument.key"
                    outlined
                    dense
                    :rules="[
                      v =>
                        !newDocuments.some((doc, i) => doc.key === v && i !== index) ||
                        $vuetify.lang.t('$vuetify.common.duplicate_error_txt'),
                      v => !!v || $vuetify.lang.t('$vuetify.common.field_required_error_txt'),
                      v =>
                        !isDateTimeFieldRequired(newDocument.key) ||
                        (isTimeSeries && !!v) ||
                        $vuetify.lang.t('$vuetify.common.field_required_error_txt'),
                    ]"
                    :disabled="
                      datetimeFieldNames.includes(newDocument.key) ||
                      selectedDataset?.idx_column_name?.toLowerCase() === newDocument.key.toLowerCase()
                    "
                  ></v-text-field>
                </v-col>
                <v-col class="py-0 my-0" cols="12" md="8">
                  <div class="d-flex">
                    <v-textarea
                      :value="formatValue(newDocument.value)"
                      @input="newDocument.value = parseValue($event)"
                      validate-on-blur
                      outlined
                      dense
                      rows="2"
                      :rules="validationRules(newDocument)"
                      :disabled="
                        toBeUpdatedDocumentId !== '' &&
                        selectedDataset?.idx_column_name?.toLowerCase() === newDocument.key.toLowerCase()
                      "
                      :placeholder="isDateTimeField(newDocument.key) ? '2025-10-31T16:00:00' : undefined"
                    ></v-textarea>
                    <v-btn
                      icon
                      @click="removeDocument(index)"
                      v-if="
                        newDocuments.length > 1 &&
                        ((!datetimeFieldNames.includes(newDocument.key) &&
                          selectedDataset?.idx_column_name?.toLowerCase() !== (newDocument.key || '').toLowerCase()) ||
                          newDocument.isPreRenderedKey === false)
                      "
                    >
                      <v-icon color="red">mdi-minus</v-icon>
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </v-form>
            <v-row class="pa-0">
              <v-col cols="12" class="d-flex justify-end">
                <v-btn outlined @click="addMoreData" color="primary">
                  {{ $vuetify.lang.t("$vuetify.common.add_more_btn") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions class="d-flex justify-end">
            <v-btn text color="error" @click="closeDocumentModel">
              {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
            </v-btn>

            <v-btn color="primary" @click="updateDocumentBtn" v-if="toBeUpdatedDocumentId !== ''">
              {{ $vuetify.lang.t("$vuetify.common.update_btn") }}
            </v-btn>
            <v-btn color="primary" @click="createNewDocument" v-else>
              {{ $vuetify.lang.t("$vuetify.common.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-if="uploadCSVDialog">
      <v-dialog
        v-model="uploadCSVDialog"
        max-width="800px"
        persistent
        scrollable
        hide-overlay
        transition="dialog-bottom-transition"
        content-class="rounded-lg"
        elevation="24"
        rounded
      >
        <v-card class="rounded-lg" elevation="24" rounded>
          <v-card-title class="ml-4">
            {{ $vuetify.lang.t("$vuetify.gpt_dataset.document_upload_header_txt") }}
          </v-card-title>
          <v-card-text v-if="!isDictionaryDataset" class="overflow-hidden">
            <v-col class="d-flex align-items-center">
              <v-icon class="text-info mr-2">mdi-information</v-icon>
              <span class="text-body-1" v-if="!isTimeSeries">
                {{ $vuetify.lang.t("$vuetify.gpt_document.file_support_type") }}
              </span>
              <span class="text-body-1" v-else>
                {{ $vuetify.lang.t("$vuetify.gpt_dataset.file_support_type_ts") }}
              </span>
            </v-col>
          </v-card-text>
          <v-card-text>
            <!-- Upload source toggle + cloud provider picker (shared with the
                 create/update dataset flow) -->
            <UploadSourceSelector
              :source="uploadSource"
              :cloud-sources="cloudSources"
              :selected-provider="cloudProvider"
              @change="onUploadSourceChange"
              @open-picker="openCloudPickerFor"
              @remove-item="handleRemoveCloudItem"
              @clear-provider="handleClearCloudProvider"
            />

            <v-col
              cols="12"
              md="6"
              v-if="uploadSource === 'cloud' && hasFolderSelected"
            >
              <v-select
                v-model="cloudExtensions"
                :items="cloudFolderExtensionOptions"
                :label="
                  $vuetify.lang.t(
                    '$vuetify.gpt_dataset.cloud_storage.extensions_label',
                  )
                "
                :hint="
                  $vuetify.lang.t(
                    '$vuetify.gpt_dataset.cloud_storage.extensions_hint',
                  )
                "
                persistent-hint
                chips
                small-chips
                multiple
                outlined
              >
                <template #selection="{ item }">
                  <v-chip
                    small
                    close
                    @click:close="
                      cloudExtensions = cloudExtensions.filter((e) => e !== item)
                    "
                  >
                    .{{ item }}
                  </v-chip>
                </template>
              </v-select>
            </v-col>

            <v-col
              cols="12"
              v-if="uploadSource === 'cloud' && cloudSelectionIsConfigurable && !isDictionaryDataset"
            >
              <v-btn color="primary" @click="openMetadataEditor" outlined class="mb-2">
                <v-icon left>mdi-file-cog</v-icon>
                {{ $vuetify.lang.t('$vuetify.gpt_dataset.configure_support') }}
              </v-btn>
            </v-col>

            <v-col
              cols="12"
              v-if="uploadSource === 'cloud' && cloudSelectionIsConfigurable && metadata && !isDictionaryDataset"
            >
              <v-textarea
                v-model="formattedMetadata"
                :label="$vuetify.lang.t('$vuetify.setup_steps.metadata_step_txt')"
                outlined
                rows="3"
                readonly
                auto-grow
              />
            </v-col>

            <template v-if="uploadSource !== 'cloud'">
            <UploadDatasetTsModal
              v-if="isTimeSeries"
              ref="UploadDatasetTsModal"
              @close-modal="uploadCSVDialog = false"
              @upload-success="handleUploadSuccess"
              @task-started="handleTimeSeriesTaskStarted"
            />
            <v-form v-else ref="dataset_form">
              <v-row v-if="isDictionaryDataset" class="align-center px-4 pb-4">
                <v-col cols="12" md="12">
                  <v-alert type="info" border="left" dense prominent>
                    <div class="font-weight-bold">
                      {{ $vuetify.lang.t("$vuetify.gpt_dataset.dictionary.info_title") }}
                    </div>
                    <div class="mt-1">
                      {{ $vuetify.lang.t("$vuetify.gpt_dataset.dictionary.upload_note") }}
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
              <v-col cols="12" md="12">
                <v-file-input
                  ref="fileInput"
                  outlined
                  :accept="
                    isDictionaryDataset
                      ? '.csv, text/csv'
                      : '.json, .csv, .xlsx, .docx, application/json, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf, .pdf, .png, .jpg, .jpeg, image/png, image/jpeg, .ppt, .pptx, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation'
                  "
                  @change="handleFileChange"
                  :label="$vuetify.lang.t('$vuetify.gpt_dataset.dataset_file')"
                  :rules="fileInputRules"
                  :error-messages="
                    fileErrorMessage ? (Array.isArray(fileErrorMessage) ? fileErrorMessage : [fileErrorMessage]) : []
                  "
                  :error="!!fileErrorMessage"
                  :hint="
                    isCheckingMandatoryColumns
                      ? $vuetify.lang.t('$vuetify.gpt_dataset.dataset_file_type_validating')
                      : $vuetify.lang.t('$vuetify.gpt_dataset.encoding_hint')
                  "
                  persistent-hint
                >
                </v-file-input>
                <v-col cols="12" v-if="isImageOrPdfOrPpt && !isDictionaryDataset">
                  <v-btn color="primary" @click="openMetadataEditor" outlined class="mb-2">
                    <v-icon left>mdi-file-cog</v-icon>
                    {{ $vuetify.lang.t("$vuetify.gpt_dataset.configure_support") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" v-if="isImageFile && imagePreviewUrl && !isDictionaryDataset">
                  <v-card class="mb-4" elevation="1">
                    <v-card-title class="subtitle-1">
                      {{ $vuetify.lang.t("$vuetify.gpt_dataset.image_preview") }}
                    </v-card-title>
                    <v-img
                      :src="imagePreviewUrl"
                      max-height="300"
                      contain
                      class="ma-2"
                    ></v-img>
                    <v-card-actions>
                      <v-btn small @click="imagePreviewUrl = null" color="secondary">
                        {{ $vuetify.lang.t("$vuetify.gpt_dataset.close_preview") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
                <v-col cols="12" v-if="isImageOrPdfOrPpt && metadata && !isDictionaryDataset">
                  <v-textarea
                    :value="formattedMetadata"
                    :label="$vuetify.lang.t('$vuetify.setup_steps.metadata_step_txt')"
                    outlined
                    rows="3"
                    readonly
                    auto-grow
                  />
                </v-col>
              </v-col>
            </v-form>
            </template>
            <!-- Applies to both local and cloud uploads; time-series ingestion
                 does not support instant training. -->
            <v-row v-if="!isDictionaryDataset && !isTimeSeries" class="pa-0">
              <v-col cols="12" class="py-0">
                <v-checkbox
                  v-model="instant_training"
                  :label="$vuetify.lang.t('$vuetify.gpt_document.instant_training')"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row class="pa-0" v-if="uploadSource === 'cloud' || !isTimeSeries">
              <v-col cols="12" class="d-flex justify-end pr-6">
                <v-btn
                  :loading="uploadBtnLoader"
                  outlined
                  @click="uploadDataset"
                  color="primary"
                  :disabled="isCheckingMandatoryColumns"
                >
                  {{ $vuetify.lang.t("$vuetify.common.upload_btn") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="d-flex justify-end pr-6">
            <v-btn
              color="error"
              outlined
              @click="closeUploadDialog"
            >
              {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <CloudFilePicker
      v-if="cloudPickerOpen"
      v-model="cloudPickerOpen"
      :project-id="$route.query.pid"
      :provider="cloudProvider"
      :allowed-extensions="cloudFileExtensions"
      :existing-items="existingCloudItems"
      @select="handleCloudFileSelect"
      @cancel="cloudPickerOpen = false"
    />

    <metadata-editor-dialog
      v-model="metadataEditorDialog"
      :is-image-file="isImageFile"
      :is-text-extraction-file="isTextExtractionFile"
      :selected-file="datasetFile"
      :initial-metadata="metadata || {}"
      :initial-is-ocr="is_ocr"
      :initial-is-text-extraction="is_text_extraction"
      @save="handleMetadataSave"
    />

    <template v-if="is_task_running">
      <v-dialog
        v-model="is_task_running"
        max-width="400px"
        persistent
        transition="dialog-bottom-transition"
        content-class="rounded-lg"
        elevation="24"
        rounded
      >
        <v-card class="rounded-lg" elevation="24" rounded>
          <v-card-title>
            <div>
              <span class="headline text-capitalize">
                {{
                  uploadingCSV
                    ? documentUploadHeader
                    : $vuetify.lang.t("$vuetify.gpt_document.delete_document_progress_header_txt")
                }}
              </span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-list-item>
              <v-list-item-icon>
                <v-progress-circular indeterminate color="primary"> </v-progress-circular>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{
                    uploadingCSV
                      ? uploadCSVMessage
                      : $vuetify.lang.t("$vuetify.gpt_document.delete_document_progress_txt")
                  }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn
              text
              color="error"
              @click="
                is_task_running = false;
                datasetFile = false;
              "
            >
              {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template v-if="task_error">
      <v-dialog
        v-model="task_error"
        max-width="600px"
        persistent
        transition="dialog-bottom-transition"
        content-class="rounded-lg"
        elevation="24"
        rounded
      >
        <v-card class="rounded-lg" elevation="24" rounded>
          <v-card-title>
            <div>
              <span class="headline text-capitalize">
                {{ documentUploadHeader }}
              </span>
            </div>
          </v-card-title>
          <v-card-text>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  {{ task_error_message }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-card-text>
          <v-card-actions class="d-flex justify-end">
            <v-btn text color="error" @click="task_error = false">
              {{ $vuetify.lang.t("$vuetify.common.close_btn") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>

    <DialogModal
      v-model="deleteDialog"
      :title="$vuetify.lang.t('$vuetify.common.confirm_alert_title_txt')"
      :message="delete_alert_message"
      :confirmButtonText="$vuetify.lang.t('$vuetify.common.confirm_btn')"
      :cancelButtonText="$vuetify.lang.t('$vuetify.common.cancel_btn')"
      @onConfirmation="deleteDocuments()"
      @onCancel="handleDeleteCancel"
      :confirmBtnLoading="deleteConfirmLoading"
    />
    <DialogModal
      v-model="downloadDialog"
      :title="$vuetify.lang.t('$vuetify.common.confirm_alert_title_txt')"
      :message="download_alert_message"
      :confirmButtonText="$vuetify.lang.t('$vuetify.common.confirm_btn')"
      :cancelButtonText="$vuetify.lang.t('$vuetify.common.cancel_btn')"
      @onConfirmation="downloadDocuments()"
      @onCancel="downloadDialog = false"
    />
    <DialogModal
      v-model="downloadAllDocumentsDialog"
      :title="
        !allDocumentsDownloadRequestSubmitted
          ? $vuetify.lang.t('$vuetify.common.confirm_alert_title_txt')
          : $vuetify.lang.t('$vuetify.download_request.request_submitted')
      "
      :message="download_alert_message"
      :confirmButtonText="$vuetify.lang.t('$vuetify.common.confirm_btn')"
      :cancelButtonText="
        allDocumentsDownloadRequestSubmitted
          ? $vuetify.lang.t('$vuetify.common.ok_btn')
          : $vuetify.lang.t('$vuetify.common.cancel_btn')
      "
      @onConfirmation="downloadAllDocuments()"
      @onCancel="
        downloadAllDocumentsDialog = false;
        allDocumentsDownloadRequestSubmitted = false;
        datasetDownloadRequestFailed = false;
      "
      :confirmButton="!allDocumentsDownloadRequestSubmitted"
      :confirmBtnLoading="documentDownloadRequestSubmission"
    >
      <v-card-text v-if="allDocumentsDownloadRequestSubmitted && !datasetDownloadRequestFailed">
        {{ $vuetify.lang.t("$vuetify.download_request.dataset_download_request_txt") }}
        {{ $vuetify.lang.t("$vuetify.download_request.request_instruction") }}
      </v-card-text>
      <div v-else-if="datasetDownloadRequestFailed">
        {{ datasetDownloadRequestFailMessage }}
      </div>
    </DialogModal>

    <DownloadDatasetHistoryModal v-model="historyDialog" :dataset-id="$route.query.datasetId" />
    <DialogModal
      v-model="alertDialog"
      :title="$vuetify.lang.t('$vuetify.common.error_title_txt')"
      :message="alertMessage"
      :confirmButtonText="$vuetify.lang.t('$vuetify.common.ok_btn')"
      :cancelButton="false"
      @onConfirmation="alertDialog = false"
    />
  </div>
</template>

<script>
import { ES_WINDOW_LIMIT, NUMBER_FORMAT_LOCALE } from "@/global/_constants";
import { mapActions, mapGetters, mapState } from "vuex";

import { ACTION_BUTTON_GROUP } from "@/components/common/buttongroup/_buttongrouptypes";
import validations from "@/helpers/validations";
import { castValue, isValidDateTimeStrict } from "@/helpers/helper_ts";

import {
  ADD_ALERT,
  CREATE_GPT_DOCUMENT,
  UPDATE_GPT_DOCUMENT,
  GET_GPT_DOCUMENTS,
  GET_GPT_DOCUMENT_BY_ID,
  TERMINATE_GPT_DOCUMENTS,
  GET_TASK_STATUS,
  DATASET_DOWNLOAD_REQUEST,
  GET_TASKS_BY_PREFIX,
  UPDATE_GPT_DATASET_FILE,
  UPDATE_GPT_DATASET_TS_FILE,
  GET_GPT_DATASET_BY_ID,
  GET_GPT_DATASETS_SUMMARY,
  UPDATE_GPT_DATASET_STATE,
} from "@/store/_actiontypes";

import { TEXT } from "@/components/common/input/_inputTypes";

import { formatDateTime } from "@/helpers/formatter";
import MetadataEditorDialog from "@/components/Projects/UploadDataset/MetadataEditor";
import ButtonGroup from "@/components/common/buttongroup/ButtonGroup";
import DialogModal from "@/components/common/DialogModal";
import DownloadDatasetHistoryModal from "./DownloadDatasetHistoryModal.vue";
import Loader from "@/components/common/loader/Loader";
import getEnv from "@/config/env";
import UploadDatasetTsModal from "./UploadDatasetTsModal.vue";
import CloudFilePicker from "@/components/Projects/UploadDataset/CloudFilePicker";
import UploadSourceSelector from "@/components/Projects/UploadDataset/UploadSourceSelector";
import { GptDatasetMapper } from "@/helpers/dataMappers/gptDataset";
import { readDatetimeFieldNames } from "@/helpers/timezone";
import { checkMandatoryColumns, isTextExtractableFile, removeOcrMetadata, createCSVBlob } from "@/helpers/helper";
import {
  cloudAllowedExtensions,
  cloudFolderExtensions,
  cloudSelectionHasImage,
  cloudSelectionHasMetadataOptions,
  cloudSelectionSupportsTextExtraction,
  cloudSelectionHasFolder,
  cloudItemsForProvider,
  deriveCloudOcrOnAdd,
  deriveCloudOcrOnRemove,
  deriveCloudTextExtractionOnAdd,
  mergeCloudSelection,
  removeCloudItem,
  removeCloudProvider,
} from "@/mixins/datasetMixin";

export default {
  props: {
    solutionType: {
      type: String,
      default: "",
    },
  },
  components: {
    ButtonGroup,
    DialogModal,
    Loader,
    DownloadDatasetHistoryModal,
    MetadataEditorDialog,
    UploadDatasetTsModal,
    CloudFilePicker,
    UploadSourceSelector
  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      account: state => state.account.account,
    }),
    ...mapGetters("loader", ["loading"]),
    fileInputRules() {
      let rules = [];
      rules.push(value => !!value || this.$vuetify.lang.t("$vuetify.gpt_dataset.dataset_file") + " is required");

      rules.push(() => !this.fileErrorMessage || this.fileErrorMessage);

      rules.push(value => {
        if (!value) return true;
        const file = value instanceof File ? value : value[0];
        return (
          !file ||
          file.size <= this.MAX_FILE_SIZE ||
          `${this.$vuetify.lang.t("$vuetify.gpt_dataset.file_size_exceeded_error")} ${this.MAX_FILE_SIZE / 1024 / 1024}MB`
        );
      });

      return rules;
    },
    validationRules() {
      return newDocument => [
        v =>
          this.toBeUpdatedDocumentId !== "" || !!v || this.$vuetify.lang.t("$vuetify.common.field_required_error_txt"),
        v =>
          !this.isDateTimeFieldRequired(newDocument.key) ||
          (this.isTimeSeries && !!v) ||
          this.$vuetify.lang.t("$vuetify.common.field_required_error_txt"),
        v =>
          !this.isDateTimeField(newDocument.key) ||
          this.isValidDateTimeStrict(v) ||
          this.$vuetify.lang.t("$vuetify.gpt_dataset.invalid_date_error"),
      ];
    },
    isTimeSeries() {
      return this.selectedDataset?.dataset_type === "time_series";
    },
    cloudFileExtensions() {
      if (this.isTimeSeries) return cloudAllowedExtensions("ts");
      if (this.isDictionaryDataset) return cloudAllowedExtensions("dictionary");
      return cloudAllowedExtensions("regular");
    },
    cloudFolderExtensionOptions() {
      if (this.isTimeSeries) return cloudFolderExtensions("ts");
      if (this.isDictionaryDataset) return cloudFolderExtensions("dictionary");
      return cloudFolderExtensions("regular");
    },
    existingCloudItems() {
      return cloudItemsForProvider(this.cloudSources, this.cloudProvider);
    },
    datetimeFieldNames() {
      return readDatetimeFieldNames(this.selectedDataset);
    },
    isImageFile() {
      if (this.datasetFile) return (this.datasetFile.type || "").includes("image");
      return cloudSelectionHasImage(this.cloudSources);
    },
    isTextExtractionFile() {
      if (this.datasetFile) return isTextExtractableFile(this.datasetFile);
      return cloudSelectionSupportsTextExtraction(this.cloudSources);
    },
    isImageOrPdfOrPpt() {
      if (!this.datasetFile) return false;
      const type = this.datasetFile.type || "";
      return type.includes("image") || isTextExtractableFile(this.datasetFile);
    },
    cloudSelectionIsConfigurable() {
      return !this.isTimeSeries && cloudSelectionHasMetadataOptions(this.cloudSources);
    },
    hasFolderSelected() {
      return cloudSelectionHasFolder(this.cloudSources);
    },
    parsedMetadata() {
      try {
        return this.metadata ? JSON.parse(this.metadata) : {};
      } catch (e) {
        console.error("Error parsing metadata:", e);
        return {};
      }
    },
    formattedMetadata() {
      if (!this.metadata) return "";
      try {
        const m = JSON.parse(this.metadata || "{}");
        return Object.keys(m).length ? JSON.stringify(m, null, 2) : "";
      } catch (e) {
        return this.metadata;
      }
    },
    dynamicTableHeaders() {
      if (this.isTimeSeries) {
        return this.tsHeaders;
      }

      if (this.isDictionaryDataset) {
        return this.headers.filter(header => header.value !== "status");
      }

      return this.headers;
    },
    isDeleteDisabled() {
      const noDocs = !(this.gptDocuments && this.gptDocuments.length > 0);
      const noSelection = this.selectedDocuments.length === 0;
      return !this.$hasProjectAccessFor([this.$pRole.ADMIN]) || (noDocs && noSelection);
    },
    paginationLimitNotice() {
      const capped = this.totalHits > ES_WINDOW_LIMIT;

      return capped
        ? this.$vuetify.lang.t(
            "$vuetify.gpt_document.pagination_limit_notice",
            ES_WINDOW_LIMIT.toLocaleString(NUMBER_FORMAT_LOCALE)
          )
        : "";
    },
  },
  watch: {
    page() {
      this.getAllDocument();
    },
    itemsPerPage() {
      if (this.page === 1) {
        this.getAllDocument();
      } else {
        this.page = 1;
      }
    },
    isImageFile: {
      immediate: true,
      handler(isImage) {
        if (isImage) this.is_ocr = true;
      },
    },
    options: {
      handler: function (newVal, _oldVal) {
        if (newVal && newVal.sortBy.length !== 0) {
          const sortField =
            this.isTimeSeries && newVal.sortBy[0] === "primary_datetime_field" ? "created_at" : newVal.sortBy[0];
          this.sortDesc = {
            [sortField]: newVal.sortDesc[0] ? "desc" : "asc",
          };
        } else {
          this.sortDesc = null;
        }
        this.getAllDocument();
      },
      deep: true,
    },
  },
  mounted() {
    this.checkSectionId();
    this.getDatasetSummary();
    this.getGptDataset();
  },
  data() {
    return {
      totalHits: 0,
      latestDocumentRequest: 0,
      gptDocuments: [],
      selectedDocuments: [],
      toBeUpdatedDocumentId: "",
      document_details: {},
      newDocuments: [{ key: "", value: "" }],
      formatDateTime,
      isLoading: false,
      TEXT: TEXT,
      ACTION_BUTTON_GROUP: ACTION_BUTTON_GROUP,
      delete_alert_message: this.$vuetify.lang.t("$vuetify.gpt_dataset.confirm_alert_msg_txt_3"),
      createNewDocumentDialog: false,
      uploadCSVDialog: false,
      detailsDialog: false,
      documentDownloadRequestSubmission: false,
      detailsLoader: false,
      deleteDialog: false,
      deleteConfirmLoading: false,
      downloadDialog: false,
      downloadAllDocumentsDialog: false,
      historyDialog: false,
      allDocumentsDownloadRequestSubmitted: false,
      taskId: "",
      download_alert_message: this.$vuetify.lang.t("$vuetify.gpt_dataset.confirm_alert_msg_all_download"),
      alertDialog: false,
      uploadingCSV: false,
      documentUploadHeader: this.$vuetify.lang.t("$vuetify.gpt_dataset.document_upload_header_txt"),
      uploadCSVMessage: this.$vuetify.lang.t("$vuetify.gpt_dataset.dataset_uploading_progress"),
      datasetFile: null,
      is_ocr: false,
      is_text_extraction: true,
      instant_training: false,
      metadata: null,
      selectedDataset: null,
      alertMessage: this.$vuetify.lang.t("$vuetify.common.unknown_err_msg_txt"),
      ...validations,
      downloadDatasetHistoryDialog: false,
      options: {},
      headers: [
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.id_header_txt"),
          align: "center",
          sortable: false,
          value: "id",
        },
        // {
        //   text: this.$vuetify.lang.t("$vuetify.table_header.name_header_txt"),
        //   align: "center",
        //   sortable: false,
        //   value: "data.name",
        // },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.created_at"),
          align: "center",
          sortable: true,
          value: "created_at",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.updated_at"),
          align: "center",
          sortable: true,
          value: "updated_at",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.status"),
          align: "center",
          sortable: false,
          value: "status",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      tsHeaders: [
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.id_header_txt"),
          align: "center",
          sortable: false,
          value: "id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.primary_datetime"),
          align: "center",
          sortable: true,
          value: "primary_datetime_field",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.table_header.actions"),
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      document_status_states: [
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.active_status_menu.all"),
          value: "",
        },
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.active_status_menu.active"),
          value: "active_status=active",
        },
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.active_status_menu.archived"),
          value: "active_status=archived",
        },
      ],
      training_status_states: [
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.train_status_menu.all"),
          value: "",
        },
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.train_status_menu.text_trained"),
          value: "text_training_status=trained",
        },
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.train_status_menu.image_trained"),
          value: "image_training_status=trained",
        },
        {
          state: this.$vuetify.lang.t("$vuetify.gpt_dataset.train_status_menu.both"),
          value: "text_training_status=trained&image_training_status=trained",
        },
      ],
      sortBy: "created_at",
      datasetDownloadRequestFailed: false,
      datasetDownloadRequestFailMessage: "",
      sortDesc: null,
      uploadBtnLoader: false,
      selected_document_state: "",
      selected_training_state: "",
      search_text: "",
      is_task_running: false,
      search: "",
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      rows: [5, 10, 20, 30, 40, 50],
      task_error: false,
      task_error_message: "",
      metadataEditorDialog: false,
      imagePreviewUrl: null,
      isDictionaryDataset: false,
      fileErrorMessage: null,
      isCheckingMandatoryColumns: false,
      MAX_FILE_SIZE: 100 * 1024 * 1024,
      uploadSource: "local",
      cloudProvider: "",
      cloudSources: [],
      cloudExtensions: [],
      cloudPickerOpen: false,
    };
  },
  beforeDestroy() {
    this.stopInterval();
    this.resetGptDataset();
  },

  methods: {
    ...mapActions("document", [
      CREATE_GPT_DOCUMENT,
      UPDATE_GPT_DOCUMENT,
      GET_GPT_DOCUMENTS,
      GET_GPT_DOCUMENT_BY_ID,
      TERMINATE_GPT_DOCUMENTS,
      DATASET_DOWNLOAD_REQUEST,
    ]),
    ...mapActions("dataset", [DATASET_DOWNLOAD_REQUEST]),
    ...mapActions("project", [
      UPDATE_GPT_DATASET_FILE,
      UPDATE_GPT_DATASET_TS_FILE,
      GET_GPT_DATASETS_SUMMARY,
      GET_GPT_DATASET_BY_ID,
      UPDATE_GPT_DATASET_STATE,
    ]),
    ...mapActions("task", [GET_TASK_STATUS, GET_TASKS_BY_PREFIX]),
    checkSectionId() {
      if (this.$route.query.section_id) {
        let document_id = this.$route.query.section_id;
        this.GET_GPT_DOCUMENT_BY_ID({
          project_id: this.$route.query.pid,
          dataset_id: this.$route.query.datasetId,
          document_id: document_id,
        }).then(
          response => {
            let item = response.data?.detail;
            item.id = document_id;
            this.updateItem(item);
          },
          error => {
            this.alertMessage = error.message;
            this.alertDialog = true;
          }
        );
      }
    },
    handleQueryOnDocuments() {
      if (this.page === 1) {
        this.getAllDocument();
      } else {
        this.page = 1;
      }
    },

    async downloadAllDocuments() {
      this.documentDownloadRequestSubmission = true;
      this.DATASET_DOWNLOAD_REQUEST({
        project_id: this.$route.query.pid,
        dataset_id: this.$route.query.datasetId,
      })
        .then(
          response => {
            this.download_alert_message = ``;
            this.taskId = response.data.detail.task_id;
          },
          error => {
            this.isLoading = false;
            this.datasetDownloadRequestFailed = true;
            console.error("Error", error);
            this.datasetDownloadRequestFailMessage = error.response.data.detail.error;
          }
        )
        .finally(() => {
          this.download_alert_message = ``;
          this.allDocumentsDownloadRequestSubmitted = true;
          this.documentDownloadRequestSubmission = false;
        });
    },
    downloadDocuments() {
      let allHeaders = new Set();
      this.selectedDocuments.forEach(doc => {
        Object.keys(doc.data).forEach(header => allHeaders.add(header));
      });
      allHeaders = Array.from(allHeaders);

      let csvRows = [];
      csvRows.push(allHeaders.join(","));

      this.selectedDocuments.forEach(doc => {
        let row = allHeaders.map(header => {
          let cell = doc.data[header] || "";
          if (this.isTimeSeries) {
            return cell;
          }
          return `"${String(cell).replace(/"/g, '""')}"`;
        });
        csvRows.push(row.join(","));
      });
      let csvContent = csvRows.join("\n");

      let blob = createCSVBlob(csvContent);
      let link = document.createElement("a");
      let url = URL.createObjectURL(blob);

      link.setAttribute("href", url);
      link.setAttribute("download", "documents.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.downloadDialog = false;
    },
    async getAllDocument() {
      const requestId = ++this.latestDocumentRequest;
      this.isLoading = true;
      this.gptDocuments = [];
      this.GET_GPT_DOCUMENTS({
        project_id: this.$route.query.pid,
        dataset_id: this.$route.query.datasetId,
        keyword: this.search_text,
        status_value: this.selected_document_state,
        train_status_value: this.selected_training_state,
        sort: this.sortDesc,
        start: (this.page - 1) * this.itemsPerPage,
        size: this.itemsPerPage,
      }).then(
        response => {
          if (requestId !== this.latestDocumentRequest) return;
          this.gptDocuments = response.data?.response.documents;
          let total_hits = response.data?.response.total_hits || 0;
          this.totalHits = total_hits;
          let returned_hits = response.data?.response.returned_hits || 0;
          const cappedHits = Math.min(total_hits, ES_WINDOW_LIMIT);
          this.pageCount = Math.max(1, Math.ceil(cappedHits / this.itemsPerPage));
          if (this.page > this.pageCount) {
            this.page = this.pageCount;
          }
          this.isLoading = false;
        },
        _error => {
          if (requestId === this.latestDocumentRequest) {
            this.isLoading = false;
          }
        }
      );
    },
    createNewDocumentClick() {
      if (this.isTimeSeries) {
        this.newDocuments = [];

        // Add datetime fields if they exist
        if (this.datetimeFieldNames.length) {
          this.datetimeFieldNames.forEach(field => {
            this.newDocuments.push({
              key: field,
              value: "",
              isPreRenderedKey: true,
            });
          });
        }
        // Add idx_column_name if it exists (treat it like datetime fields)
        if (this.selectedDataset?.idx_column_name) {
          this.newDocuments.push({
            key: this.selectedDataset.idx_column_name,
            value: "",
            isPreRenderedKey: true,
          });
        }
        // If no special fields, add empty field
        if (this.newDocuments.length === 0) {
          this.newDocuments.push({ key: "", value: "", isPreRenderedKey: false });
        }
      } else {
        this.newDocuments = [{ key: "", value: "", isPreRenderedKey: false }];
      }
      this.toBeUpdatedDocumentId = "";
      this.createNewDocumentDialog = true;
    },
    isDateTimeFieldRequired(key) {
      return this.isTimeSeries && this.datetimeFieldNames.includes(key) && this.toBeUpdatedDocumentId === "";
    },
    isDateTimeField(key) {
      return this.isTimeSeries && this.datetimeFieldNames.includes(key);
    },
    isValidDateTimeStrict,
    handleCSVUpload() {
      this.resetFileState();
      this.uploadCSVDialog = true;
    },

    addMoreData() {
      if (this.$refs.document_form.validate() === false) {
        return;
      }
      this.newDocuments.push({ key: "", value: "", isPreRenderedKey: false });
    },
    removeDocument(index) {
      this.newDocuments.splice(index, 1);
      this.$refs.document_form.validate();
    },
    createNewDocument() {
      if (this.$refs.document_form.validate() === false) {
        return;
      }
      let data = {};
      this.newDocuments.forEach(document => {
        data[document.key] = this.isTimeSeries ? castValue(document.value) : document.value;
      });
      this.CREATE_GPT_DOCUMENT({
        project_id: this.$route.query.pid,
        dataset_id: this.$route.query.datasetId,
        document: data,
      }).then(
        response => {
          if (response.status === 200) {
            this.createNewDocumentDialog = false;
            this.isLoading = true;
            setTimeout(async () => {
              await this.getAllDocument();
            }, 1000);
          } else {
            this.alertMessage = response.data?.message;
            this.alertDialog = true;
          }
        },
        error => {
          this.alertMessage = error.message;
          this.createNewDocumentDialog = false;
          this.alertDialog = true;
        }
      );
    },
    async updateDocumentBtn() {
      if (this.$refs.document_form.validate() === false) {
        return;
      }
      try {
        let data = {};
        this.newDocuments.forEach(document => {
          data[document.key] = this.isTimeSeries ? castValue(document.value) : document.value;
        });

        const response = await this.UPDATE_GPT_DOCUMENT({
          project_id: this.$route.query.pid,
          dataset_id: this.$route.query.datasetId,
          document_id: this.toBeUpdatedDocumentId,
          data: data,
        });

        if (response.status === 200) {
          if (this.$route.query.section_id) {
            this.$router.push({
              path: `/projects`,
              query: {
                pid: this.$route.query.pid,
                stype: this.$route.query.stype,
                ptab: "mairaDatasets",
                datasetId: this.$route.query.datasetId,
              },
            });
          }
          setTimeout(async () => {
            this.isLoading = true;
            await this.getAllDocument();
            this.isLoading = false;
          }, 1000);
        } else {
          this.alertMessage = response.data?.message || "An error occurred.";
          this.alertDialog = true;
        }
      } catch (error) {
        this.alertMessage = error.message || "An error occurred.";
        this.alertDialog = true;
      } finally {
        this.createNewDocumentDialog = false;
      }
    },
    handleFileChange(file) {
      this.isCheckingMandatoryColumns = true;
      if (!file) {
        this.fileErrorMessage = null;
        this.isCheckingMandatoryColumns = false;
        this.resetFileState();
        return;
      }

      const fileObj = file instanceof File ? file : Array.isArray(file) ? file[0] : file;

      if (fileObj && fileObj.size > this.MAX_FILE_SIZE) {
        this.fileErrorMessage = `${this.$vuetify.lang.t("$vuetify.gpt_dataset.file_size_exceeded_error")} ${this.MAX_FILE_SIZE / 1024 / 1024}MB`;
        this.isCheckingMandatoryColumns = false;
        this.resetFileState();
        return;
      }

      const hasFileChanged = this.datasetFile !== file;
      this.datasetFile = file;
      if (hasFileChanged) {
        this.is_ocr = false;
        this.is_text_extraction = true;
        this.metadata = null;
      }
      const isDictionary = !!this.isDictionaryDataset;
      if (isDictionary) {
        this.fileErrorMessage = null;
        const isCsv =
          (file.type && file.type.includes("csv")) || (file.name && file.name.toLowerCase().endsWith(".csv"));
        if (!isCsv) {
          this.fileErrorMessage = `${this.$vuetify.lang.t("$vuetify.gpt_dataset.dictionary.only_csv_note")}`;
          this.isCheckingMandatoryColumns = false;
          return;
        }

        checkMandatoryColumns(file)
          .then(() => {
            this.fileErrorMessage = null;
          })
          .catch(err => {
            if (Array.isArray(err)) {
              this.fileErrorMessage = err.join(", ");
            } else if (typeof err === "object" && err.message) {
              this.fileErrorMessage = err.message;
            } else {
              this.fileErrorMessage = String(err);
            }
          })
          .finally(() => {
            this.datasetFile = file;
            this.isCheckingMandatoryColumns = false;
          });
      } else {
        this.isCheckingMandatoryColumns = false;
      }
      // is_ocr describes the file in hand, so re-picking must be able to unset it.
      // Images have no alternative extraction method so they force it on;
      // PDF/PPT/PPTX/DOCX default to text extraction instead, leaving OCR as an opt-in.
      this.is_ocr = (file.type || "").includes("image");
      if (this.isImageFile) {
        this.imagePreviewUrl = URL.createObjectURL(file);
      }
      if (!this.is_ocr) {
        this.metadata = removeOcrMetadata(this.metadata);
      }
      if (this.isImageOrPdfOrPpt) {
        this.openMetadataEditor();
      }
    },
    startInterval(task_id) {
      this.intervalId = setInterval(() => {
        this.GET_TASK_STATUS({
          project_id: this.$route.query.pid,
          task_id: task_id,
        }).then(
          response => {
            if (response.data.detail.response.status === "success") {
              this.stopInterval();
              this.getAllDocument();
            }
            if (response.data.detail.response.status === "failed") {
              this.stopInterval();
              this.task_error = true;
              this.task_error_message = response.data.detail.response.message;
              // A batch can fail partially — some files from a cloud folder may
              // have been ingested before another one errored. Refresh so the
              // list reflects whatever did land.
              this.getAllDocument();
            }
          },
          error => {
            this.stopInterval();
            clearInterval(this.intervalId);
            this.alertMessage = error.message;
            this.alertDialog = true;
          }
        );
      }, getEnv("VUE_APP_POLLING_INTERVAL"));
    },
    stopInterval() {
      this.is_task_running = false;
      this.selectedDocuments = [];
      clearInterval(this.intervalId);
    },
    deleteDocuments() {
      this.deleteConfirmLoading = true;
      let documentIds = this.selectedDocuments.map(document => document.id);
      this.TERMINATE_GPT_DOCUMENTS({
        project_id: this.$route.query.pid,
        dataset_id: this.$route.query.datasetId,
        documentIds,
      })
        .then(
          response => {
            if (response.status === 202) {
              this.is_task_running = true;
              this.startInterval(response.data?.detail.task_id);
              this.deleteDialog = false;
            } else if (response.status === 200) {
              this.getAllDocument();
              this.deleteDialog = false;
            } else {
              this.alertMessage = response.data?.message;
              this.alertDialog = true;
            }
          },
          error => {
            this.alertMessage = error.message;
            this.deleteDialog = false;
            this.alertDialog = true;
          }
        )
        .finally(() => {
          this.deleteConfirmLoading = false;
        });
    },
    handleDeleteCancel() {
      this.deleteDialog = false;
      this.deleteConfirmLoading = false;
    },
    uploadDataset() {
      if (this.uploadSource === "cloud") {
        if (!this.cloudSources.some((s) => s.items?.length > 0)) {
          this.$store.dispatch(
            `alert/${ADD_ALERT}`,
            {
              message: this.$vuetify.lang.t(
                "$vuetify.gpt_dataset.cloud_storage.no_file_selected",
              ),
              color: "warning",
            },
            { root: true },
          );
          return;
        }
        this.uploadBtnLoader = true;
        // Call the mapActions helper on `this` — detaching it into a local
        // variable loses the binding it needs to reach this.$store.
        const cloudPayload = {
          project_id: this.$route.query.pid,
          datasetId: this.$route.query.datasetId,
          cloud_sources: this.cloudSources,
          is_ocr: this.is_ocr,
          is_text_extraction: this.is_text_extraction,
          metadata: this.metadata,
          // Ignored by the time-series action, which has no instant-training path.
          instant_training: this.instant_training,
        };
        const uploadCloudFile = this.isTimeSeries
          ? this.UPDATE_GPT_DATASET_TS_FILE(cloudPayload)
          : this.UPDATE_GPT_DATASET_FILE(cloudPayload);
        uploadCloudFile
          .then((res) => {
            this.uploadingCSV = true;
            this.uploadCSVDialog = false;
            this.startInterval(res.data.detail?.task_id);
            this.is_task_running = true;
            // Only discard the picked files once they are accepted; on failure
            // the dialog stays open so the user can retry as-is.
            this.resetCloudState();
            this.resetFileState();
          })
          .catch((err) => {
            console.error("Upload error:", err);
            this.handleUploadError(err, true);
          })
          .finally(() => {
            this.uploadBtnLoader = false;
          });
        return;
      }

      if (!this.$refs.dataset_form.validate()) return;
      this.uploadBtnLoader = true;
      if (this.isTimeSeries) {
        if (this.$refs.UploadDatasetTsModal) {
          this.$refs.UploadDatasetTsModal.uploadDataset();
        } else {
          this.uploadBtnLoader = false;
        }
      } else {
        this.UPDATE_GPT_DATASET_FILE({
          project_id: this.$route.query.pid,
          datasetId: this.$route.query.datasetId,
          datasetFile: this.datasetFile,
          is_ocr: this.is_ocr,
          is_text_extraction: this.is_text_extraction,
          instant_training: this.instant_training,
          metadata: this.metadata,
        })
          .then(res => {
            this.uploadingCSV = true;
            this.uploadCSVDialog = false;
            this.startInterval(res.data.detail?.task_id);
            this.is_task_running = true;
          })
          .catch(err => {
            console.error("Upload error:", err);
            this.handleUploadError(err);
          })
          .finally(() => {
            this.uploadBtnLoader = false;
            this.resetFileState();
          });
      }
    },
    onUploadSourceChange(source) {
      // No need to reset $refs.fileInput here: the v-file-input lives in the
      // local-source branch, so switching source unmounts it and it remounts
      // clean. Calling reset() would emit `change` synchronously and re-enter
      // handleFileChange(), clobbering the state set below.
      this.uploadSource = source || "local";
      this.cloudPickerOpen = false;
      this.cloudProvider = "";
      this.cloudSources = [];
      this.cloudExtensions = [];
      this.fileErrorMessage = null;
      this.isCheckingMandatoryColumns = false;
      this.resetFileState();
    },
    openCloudPickerFor(provider) {
      this.cloudProvider = provider;
      this.cloudPickerOpen = true;
    },
    handleCloudFileSelect(selectedItems) {
      const before = this.cloudSources;
      this.cloudSources = mergeCloudSelection(
        before,
        this.cloudProvider,
        selectedItems,
      );
      this.is_ocr = deriveCloudOcrOnAdd(before, this.cloudSources, this.is_ocr);
      this.is_text_extraction = deriveCloudTextExtractionOnAdd(before, this.cloudSources, this.is_text_extraction);
      if (this.cloudSelectionIsConfigurable && !this.isDictionaryDataset) {
        this.openMetadataEditor();
      }
    },
    handleRemoveCloudItem({ provider, itemId }) {
      this.cloudSources = removeCloudItem(this.cloudSources, provider, itemId);
      this.is_ocr = deriveCloudOcrOnRemove(this.cloudSources, this.is_ocr);
    },
    handleClearCloudProvider(provider) {
      this.cloudSources = removeCloudProvider(this.cloudSources, provider);
      this.is_ocr = deriveCloudOcrOnRemove(this.cloudSources, this.is_ocr);
    },
    handleTimeSeriesTaskStarted(taskData) {
      this.uploadCSVDialog = false;
      this.uploadingCSV = true;
      this.startInterval(taskData.taskId);
      this.is_task_running = true;
    },
    handleUploadError(err, isCloudUpload = false) {
      const detail = err.response?.data?.detail;
      const isEncodingError =
        err.response?.status === 400 &&
        typeof detail?.error === "string" &&
        detail.error.includes("Invalid encoding");
      
      const serverMessage = isCloudUpload
        ? typeof detail === "string"
          ? detail
          : typeof detail?.error === "string"
            ? detail.error
            : typeof detail?.message === "string"
              ? detail.message
              : null
        : null;
      const errorMessage = isEncodingError
        ? this.$vuetify.lang.t("$vuetify.gpt_dataset.encoding_error")
        : serverMessage ||
          this.$vuetify.lang.t("$vuetify.gpt_dataset.dataset_submission_error");
      this.$store.dispatch(
        `alert/${ADD_ALERT}`,
        {
          message: errorMessage,
          color: "error",
        },
        { root: true },
      );
    },
    detailsModal(item) {
      this.detailsDialog = true;
      this.document_details = item;
      // this.detailsLoader = true;
    },
    updateItem(item) {
      this.createNewDocumentDialog = true;
      this.newDocuments = Object.keys(item.data)
        .filter(key => key !== "id")
        .map(key => {
          const isPreRendered =
            this.datetimeFieldNames.includes(key) ||
            (this.selectedDataset?.idx_column_name || "").toLowerCase() === (key || "").toLowerCase();
          return { key, value: item.data[key], isPreRenderedKey: !!isPreRendered };
        });
      this.toBeUpdatedDocumentId = item.id;
    },
    closeDocumentModel() {
      if (this.$route.query.section_id) {
        this.$router.push({
          path: `/projects`,
          query: {
            pid: this.$route.query.pid,
            stype: this.$route.query.stype,
            ptab: "mairaDatasets",
            datasetId: this.$route.query.datasetId,
          },
        });
      }
      this.createNewDocumentDialog = false;
    },
    deleteItem(item) {
      this.selectedDocuments = [item];
      this.deleteDialog = true;
    },
    getDatasetSummary() {
      this.GET_GPT_DATASETS_SUMMARY({
        project_id: this.$route.query.pid,
        dataset_id: this.$route.query.datasetId,
      })
        .then(res => {
          this.selectedDataset = res?.data?.response?.dataset || null;
          const tags = res?.data?.response?.dataset?.tags || [];
          this.isDictionaryDataset = Array.isArray(tags) && tags.includes("dictionary");
        })
        .catch(err => {
          console.error("err", err);
        });
    },
    formatValue(val) {
      return typeof val === "object" && val !== null ? JSON.stringify(val, null, 2) : val;
    },
    parseValue(val) {
      try {
        const parsed = JSON.parse(val);
        return typeof parsed === "object" ? parsed : val;
      } catch (e) {
        return val;
      }
    },
    async getGptDataset() {
      try {
        await this.GET_GPT_DATASET_BY_ID({
          project_id: this.$route.query.pid,
          dataset_id: this.$route.query.datasetId,
        });
      } catch (error) {
        console.error("Error fetching dataset:", error);
      }
    },
    openMetadataEditor() {
      this.metadataEditorDialog = true;
    },
    handleMetadataSave({ metadata, isOcr, isTextExtraction }) {
      this.metadata = metadata;
      this.is_ocr = isOcr;
      this.is_text_extraction = isTextExtraction;
    },
    resetGptDataset() {
      this.UPDATE_GPT_DATASET_STATE({
        dataset: GptDatasetMapper.mapBackendToFrontend({
          dataset_id: "",
          description: "",
          idx_column_name: "",
          image_url_column: "",
          is_idx_fillup_if_empty: true,
          name: "",
          secondary_idx_column: "",
        }),
      });
    },
    resetFileState() {
      this.datasetFile = null;
      this.is_ocr = false;
      this.is_text_extraction = true;
      this.metadata = null;
      this.imagePreviewUrl = null;
      this.instant_training = false;
    },
    resetCloudState() {
      this.uploadSource = "local";
      this.cloudProvider = "";
      this.cloudSources = [];
      this.cloudExtensions = [];
      this.cloudPickerOpen = false;
    },
    closeUploadDialog() {
      this.uploadCSVDialog = false;
      this.resetFileState();
      this.resetCloudState();
      this.fileErrorMessage = null;
      this.isCheckingMandatoryColumns = false;
    },
    handleUploadSuccess() {
      this.getAllDocument();
    },
  },
};
</script>

<style></style>
